import { routes } from './routes';
import { staticData } from './staticData';
import { constants } from './constants';

export const useValues = () => {
  return {
    routes,
    staticData,
    constants,
    getPageLink: (pageName) => `${constants.pageLinkPrefix}${pageName}`,
    getPageUrl: (pageName) => `https://${constants.pageLinkPrefix}${pageName}`,
    getLinkUrl: (pageName, token) =>
      `https://${constants.pageLinkPrefix}${pageName}/${token}`,
  };
};
